import * as React from "react"
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"

// View components
import Verify from "./views/Verify"
import ActiveCountry from "./views/ActiveCountry"
import BasicInfo from "./views/BasicInfo"
import ParentInfo from "./views/ParentInfo"
import AddressInfo from "./views/AddressInfo"
import WorkStatus from "./views/WorkStatus"
import ArtistStatus from "./views/ArtistStatus"
import Dashboard from "./views/Dashboard"
import EntryEditor from "./views/EntryEditor"
import Declaration from "./views/Declaration"
import Complete from "./views/Complete"
import Error from "./views/Error"
import ServiceError from "./views/ServiceError"
import UnsupportedBrowser from "./views/UnsupportedBrowser"
import { TSteps } from "./reducers/appReducers"
import HeaderWithBanner from "./components/HeaderWithBanner"
import Header from "./components/Header"

const BANNER_HEADER_VIEWS: TSteps[] = ["BasicInfo", "Verify", "Error"]
const NO_HEADER_VIEWS: TSteps[] = ["Complete", "ServiceError", "UnsupportedBrowser"]

interface IViewRouter {
    view: TSteps
}

const ViewRouter: React.FC<IViewRouter> = (props) => {
    const { view } = props;

    const { userInfo, langPack } = useSelector((store: AppTypes.ReducerState) => (
        {
            langPack: store.config.langPack,
            userInfo: store.userInfo
        }
    ))

    const { activeCountry} = userInfo;

    const routes = {
        "Verify": <Verify />,
        "ActiveCountry": <ActiveCountry />,
        "BasicInfo": <BasicInfo />,
        "AddressInfo": <AddressInfo />,
        "WorkStatus": <WorkStatus />,
        "ParentInfo": <ParentInfo />,
        "ArtistStatus": <ArtistStatus />,
        "Dashboard": <Dashboard />,
        "EntryEditor": <EntryEditor />,
        "Declaration": <Declaration />,
        "Complete": <Complete />,
        "Error": <Error />,
        "ServiceError": <ServiceError />,
        "UnsupportedBrowser": <UnsupportedBrowser />
    }  

    const headerBannerName = `headerBanner${activeCountry}`
    const bannerImage = langPack[headerBannerName] ? langPack[headerBannerName] : "header-banner.png"
    return (
        <div className="view">
            {(!NO_HEADER_VIEWS.includes(view)) &&
                (BANNER_HEADER_VIEWS.includes(view)
                    ? <HeaderWithBanner bannerImage={bannerImage} />
                    : <Header />)}
            {routes[view]}
        </div>
    )
}

export default ViewRouter